<script>
	import { onMount } from 'svelte'

	let is_browser_supported = true

	onMount(() => {
		try {
			// Making a BigInt will break Safari iOS <= 13 && IE
			BigInt(1)
		} catch (_error) {
			is_browser_supported = false
		}
	})
</script>

{#if !is_browser_supported}
	<div>
		<img src="/wp-content/themes/theme/img/unsupported-dino.png" alt="Unsupported Browser">
		<p class="desktop-text">This website is not designed to work on your browser. If you're on a desktop computer, please upgrade your browser.</p>
		<p class="mobile-text">This website is not designed to work on your browser. If you're on a mobile device, please switch browsers, upgrade your operating system, or upgrade your device.</p>
	</div>
{/if}

<style>
	div {
		background-color: #ff220b;
		display: flex;
		width: 100%;
		height: 9rem;
		justify-content: center;
		align-items: center;
	}

	p {
		color: #fff;
		display: none;
		font-family: 'Protipo Wide', 'Helvetica Neue', Helvetica, Arial, sans-serif;
		font-size: 13px;
	}

	@media screen and (max-width: 800px) {
		.mobile-text {
			display: initial;
		}
	}

	@media screen and (min-width: 800px) {
		.desktop-text {
			display: initial;
		}
	}
</style>
